export default __webpack_public_path__ + "static/media/before-after-2.8dc56180.png";